import { t } from "@ebay/i18n-ebay";
import { getPropsForClickTracking, composeAttrsForClickTracking } from "../../utils/tracking";
import { LOCATION_TOURTIP_CTA_CLICK_ID, LOCATION_TOURTIP_CLOSE_CLICK_ID } from "./const";

<div class="map-location-tourtip">
  <ebay-tourtip
    a11yCloseText=t("mapview/map", "locationTourtipDismiss")
    placement="bottom-start"
    open=state.opened
    offset=-15
    onCollapse("onCollapse")
    ...getPropsForClickTracking([{ ...composeAttrsForClickTracking(LOCATION_TOURTIP_CLOSE_CLICK_ID, "button") }])
  >
    <@host>
      <span/>
    </@host>
    <@heading>${t("mapview/map", "locationTourtipTitle")}</@heading>
    <@content>
      <p>${t("mapview/map", "locationTourtipMessage")}</p>
    </@content>
    <@footer>
      <ebay-button
        class="tourtip-cta-button"
        priority="primary"
        on-click("onCollapse")
        data-testid="location-tourtip-got-it-btn"
        ...getPropsForClickTracking([{ ...composeAttrsForClickTracking(LOCATION_TOURTIP_CTA_CLICK_ID, "button") }])
      >
        ${t("mapview/map", "locationTourtipButton")}
      </ebay-button>
    </@footer>
  </ebay-tourtip>
</div>
